import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { Preloader } from '../../../components/UI/ComponentsUI';
import { isNullOrEmpty } from '../../../utils/util';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import ModalBottomSheetUI from '../../../components/UI/ModalBottomSheetUI';

const SummaryReceipt = (props) => {
    const [open, setOpen] = useState(false);
    const [info, setInfo] = useState({ data: [], preloader: true });

    useEffect(() => {
        if (!isNullOrEmpty(props.filter)) {
            getSummary();
        }
        // eslint-disable-next-line
    }, [props.filter, props.physicalConfirmation]);

    const getSummary = () => {
        props.getSummary(props.filter, (response) => {
            setInfo({
                data: response || [],
                preloader: false
            });
        });
    };

    const closeModal = () => {
        setOpen(false);
    }

    return (
        <>
            <div key={props.id || 'chipShed'}
                onClick={() => {
                    setOpen(open ? false : true);
                }}
                className="chip"
                style={{
                    backgroundColor: 'var(--third-text-color)',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '12px'
                }}>
                {`${info.data.length} ${info.data.length <= 1 ? 'GALPÃO' : 'GALPÕES'}`}
            </div>
            <ModalBottomSheetUI
                open={open}
                maxHeight="65%"
                onClose={closeModal}
                header={`RESUMO: ${info.data.length}  ${info.data.length <= 1 ? "GALPÃO" : "GALPÕES"}`}
                data={
                    info.preloader ? <Preloader /> :
                        info.data.map((item) => {
                            return (
                                <div key={`div-${item.shed} ${item.partNumberCode}`}>
                                    <div
                                        style={{ wordBreak: 'break-word', fontWeight: 'bold' }}
                                        key={`item-${item.shed} ${item.partNumberCode}`}
                                        className="sixth-text-color">
                                        GALPÃO {item.shed} - {item.partNumberCode}
                                    </div>
                                    <br />
                                </div>
                            )
                        })} />
        </>
    );

}
const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        physicalConfirmation: state.physicalConfirmationReducer.physicalConfirmation,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSummary: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getSummary(filter, callback));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SummaryReceipt)));